export enum BillOfLadingType {
  OriginalBl,
  SeawayBl
}
